import PremsPremiumItemApiService from "../services/prems-premium-item.api.service";

Shopware.Application.addServiceProvider('premsPremiumItemApiService', container => {
    const initContainer = Shopware.Application.getContainer('init');
    return new PremsPremiumItemApiService(initContainer.httpClient, container.loginService);
});
